'use client';
import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';
import type { StockMapProps } from '../createStockPage';
import { StockMapLoading } from '../stockMapLoading';

// Client-only + lazy. The whole map UI subtree (react-map-gl / mapbox-gl and
// the recharts market panel) only runs in the browser, so keep it out of the
// SSR render path and the server worker bundle. ssr:false must live in a client
// component; the cast restores the concrete prop type next/dynamic widens.
const CrownSigniaInventoryMap = dynamic(
  () => import('./crown-signiaMap').then((m) => m.CrownSigniaInventoryMap),
  {
    ssr: false,
    loading: () => <StockMapLoading />,
  },
);

export default CrownSigniaInventoryMap as ComponentType<StockMapProps>;
